import {
  KIOSK__SELECTION_GREETING_AFTERNOON,
  KIOSK__SELECTION_GREETING_EVENING,
  KIOSK__SELECTION_GREETING_MORNING,
} from 'translations/constants';
import { TKioskSelectionFeed } from 'types/kiosk/TKioskSelectionFeed';
import { TKioskSession } from 'types/kiosk/TKioskSession';

export type KioskSection = 'active' | 'planned' | 'other';
export type KioskTapIntent = 'start' | 'end';

/** Translation key for the time-of-day greeting (device-local hour): 05–11 morning, 12–17 afternoon, else evening. */
export const getGreetingKey = (date: Date = new Date()) => {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return KIOSK__SELECTION_GREETING_MORNING;
  if (hour >= 12 && hour < 18) return KIOSK__SELECTION_GREETING_AFTERNOON;
  return KIOSK__SELECTION_GREETING_EVENING;
};

/** Case-insensitive substring match on fullName, applied independently to each list. Empty query → unchanged. */
export const filterFeed = (feed: TKioskSelectionFeed, query: string): TKioskSelectionFeed => {
  const q = query.trim().toLowerCase();
  if (!q) return feed;
  const match = (fullName: string) => fullName.toLowerCase().includes(q);
  return {
    active: feed.active.filter(e => match(e.fullName)),
    planned: feed.planned.filter(e => match(e.fullName)),
    allEmployees: feed.allEmployees.filter(e => match(e.fullName)),
  };
};

/** Total rows across all three lists. */
export const countFeed = (feed: TKioskSelectionFeed): number =>
  feed.active.length + feed.planned.length + feed.allEmployees.length;

/**
 * Display-only for US 7346: the intent the future clock-in/out story will consume.
 * Active → end-registration; Planned / Other → start-registration.
 */
export const getKioskTapIntent = (section: KioskSection): KioskTapIntent => (section === 'active' ? 'end' : 'start');

/** A missing mode (stale pre-upgrade cached session) behaves exactly like 'OpenList'. */
export const isPinGatedSession = (session: TKioskSession | null): boolean =>
  Boolean(session?.authenticationMode) && session.authenticationMode !== 'OpenList';
